import React, { CSSProperties } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { AppState } from "../../pages/main.reducer";
import { convertPrice, getCurrencyLabel } from "../../common/currencyUtils";

export const NumberMoneyDual: React.FC<{
  value: number;
  style?: CSSProperties;
}> = ({ value, style }) => {
  const conversionRate = useSelector<AppState, number>(
    (store) => store.common.conversionRate
  );

  const kmValue = convertPrice(value, "KM", conversionRate);

  return (
    <span style={{ whiteSpace: "nowrap", ...style }}>
      <NumberFormat
        value={value}
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale={true}
      />
      &nbsp;<sup style={{ fontSize: "70%" }}>{getCurrencyLabel("DIN")}</sup>
      {conversionRate > 0 && (
        <span style={{ color: "#888" }}>
          {" ("}
          <NumberFormat
            value={kmValue}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
          />
          &nbsp;<sup style={{ fontSize: "70%" }}>KM</sup>
          {")"}
        </span>
      )}
    </span>
  );
};
